import axios from 'axios';

// ヘッダー・サイドバー・画面が同じ GET を同時に出すと、同じ応答を何本も取りに行く。
// React の開発モード（StrictMode）では各 effect が2回走るため、これが二重に見えていた。
// 進行中の取得には相乗りし、直後の再取得は短時間だけ使い回す。
const inflight = new Map();
const cache = new Map();
const DEFAULT_TTL = 5000;

export const sharedGet = (url, { ttl = DEFAULT_TTL, ...config } = {}) => {
  const key = `${url}|${JSON.stringify(config.params || {})}`;
  const hit = cache.get(key);
  if (hit && Date.now() - hit.at < ttl) return Promise.resolve(hit.data);
  if (inflight.has(key)) return inflight.get(key);
  const p = axios.get(url, config)
    .then((r) => { cache.set(key, { at: Date.now(), data: r.data }); return r.data; })
    .finally(() => inflight.delete(key));
  inflight.set(key, p);
  return p;
};

export const invalidateSharedGet = (urlPart) => {
  for (const k of [...cache.keys()]) if (k.includes(urlPart)) cache.delete(k);
};
